import { configureStore } from '@reduxjs/toolkit';

import AccountsReducer from 'features/accounts/reducers';
import CredentialsReducer from 'features/credentials/reducers';
import ChangePasswordReducer from 'features/change-password/reducers';
import ResetPasswordReducer from 'features/reset-password/reducers';
import ErrorMessagesReducer from 'features/error-messages/reducers';
import ApplicationsReducer from 'features/applications/reducers';
import UserAgreementsReducer from 'features/user-agreements/reducers';
import CustomersReducer from 'features/customers/reducers';
import SigninOptionsReducer from 'features/signin-options/reducers';

export const reducers = {
    accounts: AccountsReducer,
    applications: ApplicationsReducer,
    credentials: CredentialsReducer,
    customers: CustomersReducer,
    changePassword: ChangePasswordReducer,
    errorMessages: ErrorMessagesReducer,
    resetPassword: ResetPasswordReducer,
    userAgreements: UserAgreementsReducer,
    signinOptions: SigninOptionsReducer,
};

const sortObj = (obj) => {
    return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
            result[key] = obj[key];
            return result;
        }, {});
};

const sorted = sortObj(reducers);

// added this middleware  to disable this error - A non-serializable value was detected in the state, in the path...
// @todo disable if better way is found
export const store = configureStore({
    reducer: sorted,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
